import React from 'react'

const Warehouses = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Warehouses</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active">Warehouses</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-building me-2"></i>
                  Warehouses Management
                </h5>
                <p>Manage warehouse locations, view warehouse details, and monitor inventory levels at each warehouse.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Warehouses

